import type { Tokens } from "@okta/okta-auth-js";

/**
 * Use the Okta ID token for backend API calls.
 * ID tokens are standard JWTs (typ: JWT) signed with keys from Okta's JWKS.
 * Okta org-AS access tokens (typ: application/okta-internal-at+jwt) are intended
 * for Okta SSO internals and often cannot be verified by resource servers.
 */
export function getApiBearerToken(tokens: Tokens): string {
  return tokens.idToken?.idToken || "";
}

export function clearStaleAuthTokens() {
  [
    "accessToken",
    "idToken",
    "oktaAccessToken",
    "refreshToken",
    "currentUser",
    "user",
    "serviceProviderId",
  ].forEach((key) => localStorage.removeItem(key));
}
